import im1 from '../assets/images/im1.png';

export default function AboutUs() {
  return (
    <section className="scale-90 transform">
      <div className="grid grid-cols-6 gap-4 px-4 sm:px-6 lg:px-10 py-4">
        {/* Header */}
        <div className="col-span-6 sm:col-start-2 sm:col-span-4 text-center sm:text-left text-2xl Rubik-ExtraBold text-primary"></div>

        {/* Image */}
        <div className="col-span-6 sm:col-start-1 sm:col-span-3 flex justify-center sm:justify-start py-5 px-16">
          <img
            src={im1}
            alt="About Us"
            className="w-full max-w-sm sm:max-w-lg lg:max-w-xl rounded-lg shadow-lg mx-1.5"
          />
        </div>

        {/* Content */}
        <div className="col-span-6 sm:col-start-4 sm:col-span-3 flex flex-col gap-6">
          {/* About Us Section */}
          <div className="shadow-md px-5 py-4 rounded-lg bg-blue-50">
            <h1 className="text-3xl md:text-5xl Source-Code-ExtraBold text-black py-3">
              About Us
            </h1>
            <p className="text-primary text-lg md:text-xl Rubik-Light leading-relaxed">
            Welcome to Aram Eyecare and Opticals, your trusted optical store and the go-to place for affordable eyewear online. Founded by Mohamed Thaha Musthafa, Aram offers comprehensive eyecare services, including treatment for Computer Vision Syndrome (CVS), Myopia, Amblyopia, Presbyopia, and more. We specialize in branded eyeglasses in ChinnaSalem, designer sunglasses for men/women, and prescription glasses online, ensuring both quality and comfort. Whether you're looking for blue light blocking glasses, contact lenses, or a kids' eyewear store, we have something for everyone. We also provide thorough eye checkup services and early glaucoma diagnosis using advanced techniques. Our mission is to elevate optometry standards in India by offering affordable eye care and glasses, while bringing stylish, UV-protected sunglasses to our customers. At Aram, we are dedicated to making your vision care experience exceptional with personalized, professional service.
</p>
          </div>

          {/* Expanding Our Reach Section */}
          <div className="shadow-md px-5 py-4 rounded-lg bg-violet-50">
            <h1 className="text-3xl md:text-5xl Source-Code-ExtraBold text-black py-3">
              Expanding Our Reach
            </h1>
            <p className="text-primary text-lg md:text-xl Rubik-Light leading-relaxed">
          With three established local stores and a growing reputation for excellence, Aram Eyecare is now automating its operations to bring a wide range of products to the cloud. Our e-commerce platform makes it easier than ever to purchase affordable eyewear online and prescription glasses online with fast and reliable delivery across Tamil Nadu. We specialize in branded eyeglasses , designer sunglasses for men/women, and blue light blocking glasses. At Aram, we blend traditional expertise with modern technology to provide world-class eyecare services. Join us in our mission to deliver affordable eye care and glasses and empower vision for all, one eye at a time.
 </p>
          </div>
        </div>
      </div>
    </section>
  );
}
